import Swiper from 'swiper/bundle'

function featuredNewsSlider() {
  const swiper = document.querySelector('.swiper')

  if (!swiper) return

  const featuredNewsSlider = new Swiper('.swiper', {
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    loop: true,
    speed: 1500,
    autoplay: {
      delay: 4000,
    },
  })
}

export default featuredNewsSlider
